import React from 'react';

function DisclaimerBottom() {
    return <span>
        This notice does not serve as or replace an authorization sent by the member's carrier. Please refer back to the original authorization for additional details related to this study. Covera Health does not handle eligibility, claims, authorizations, payments, or benefits. Please contact the carrier of record for questions on eligibility, payments or administration. In addition, please remember that it is the practice's responsibility to ensure that the radiologists are credentialed and in-network for the member's plan. Moreover, if your facility does not perform services listed above, please contact the appropriate carrier or utilization management vendor. 
    </span>
}

export default DisclaimerBottom;